import React, { useState, useMemo } from 'react';
import './AnnouncementBanner.css';
import { Row, Col } from 'react-bootstrap';
import { FaBell } from 'react-icons/fa';
import { getActiveAnnouncements } from '../../data/announcements';
import IndependenceDayDecor from './IndependenceDayDecor';

const AnnouncementBanner = () => {
  const active = useMemo(() => getActiveAnnouncements('announcement'), []);
  const [dismissedIds, setDismissedIds] = useState(() => new Set());

  const toShow = active.filter((a) => a && !dismissedIds.has(a.id));
  const item = toShow[0] ?? null;

  const handleDismiss = () => {
    if (item) setDismissedIds((prev) => new Set(prev).add(item.id));
  };

  if (!item) return null;

  const isIndependence =
    item.theme === 'independence-day' || item.iconType === 'independence';
  const sectionClass = [
    'announcement-section',
    isIndependence && 'announcement-section--independence',
  ]
    .filter(Boolean)
    .join(' ');

  const renderIcon = () => {
    if (isIndependence) {
      return <IndependenceDayDecor />;
    }
    return (
      <div className="announce-icon-wrap" aria-hidden="true">
        <FaBell className="announce-bell-icon" />
      </div>
    );
  };

  return (
    <section className={sectionClass} role="status" aria-live="polite">
      <div className="gn-container">
        <Row className="align-items-center g-3">
          <Col md={1} xs={2} className="text-md-start text-center">
            {renderIcon()}
          </Col>
          <Col md={9} xs={10}>
            <div className="announce-content">
              <span className="announce-eyebrow">{item.eyebrow}</span>
              <h3 className="announce-title">{item.title}</h3>
              <p className="announce-desc" style={{ marginLeft: '5px' }}>
                {item.description}
              </p>
            </div>
          </Col>
          <Col md={2} className="text-md-end text-center">
            <div className="announce-actions">
              {item.ctaLabel && item.ctaHref && (
                <a className="btn btn-gn-secondary me-2" href={item.ctaHref}>
                  {item.ctaLabel}
                </a>
              )}
              <button className="announce-dismiss" onClick={handleDismiss} aria-label="Dismiss announcement">
                Dismiss
              </button>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default AnnouncementBanner;
